import { HttpErrorResponse } from '@angular/common/http';
import { Injector } from '@angular/core';
import { TosterService } from 'src/shared/services/toster.service';

export function handleHttpErrors(injector: Injector, httpError: HttpErrorResponse) {
  if (!!httpError.status) {
    const toaster = injector.get(TosterService);
    const errorPayload = httpError.error?.error ?? httpError.error;
    const ERROR_MESSAGE =
      errorPayload?.details ??
      errorPayload?.message ??
      httpError.message ??
      (httpError.status === 404 ? 'Requested resource was not found.' : 'Unexpected error occurred.');
    toaster.error(ERROR_MESSAGE);
    return;
  }
}
